import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TeltonikaHomeComponent } from './teltonika-home/teltonika-home.component';
import { TeltonikaDeviceComponent } from './teltonika-device/teltonika-device.component';
import { TeltonikaReportingComponent } from './teltonika-reporting/teltonika-reporting.component';
import { TeltonikaTagsComponent } from './teltonika-tags/teltonika-tags.component';
import { TeltonikaTasksComponent } from './teltonika-tasks/teltonika-tasks.component';
import { CreateUpdateTeltonikaTaskComponent } from './teltonika-tasks/create-update-teltonika-task/create-update-teltonika-task.component';
import { TeltonikaAdminComponent } from './teltonika-admin/teltonika-admin.component';
import { TeltonikaDeviceTerminalComponent } from './teltonika-device/teltonika-device-terminal/teltonika-device-terminal.component';
import { TeltonikaManageTagDevicesComponent } from './teltonika-manage-tag-devices/teltonika-manage-tag-devices.component';
import { TeltonikaDeviceReverseSshComponent } from './teltonika-device/teltonika-device-reverse-ssh/teltonika-device-reverse-ssh.component';
import { TeltonikaAuditLogComponent } from './teltonika-audit-log/teltonika-audit-log.component';
import { TeltonikaUpdateDefaultCredentialsModalComponent } from './modals/teltonika-update-default-credentials-modal/teltonika-update-default-credentials-modal.component';
import { TeltonikaSelectEmailsModalComponent } from './modals/teltonika-select-emails-modal/teltonika-select-emails-modal.component';
import { TeltonikaUpdateDeviceModalComponent } from './modals/teltonika-update-device-modal/teltonika-update-device-modal.component';
import { CreateCustomDeviceComponent } from '@huge-monorepo/shared/components';
import { TeltonikaDeviceReportComponent } from './teltonika-reporting/teltonika-device-report/teltonika-device-report.component';
import { TeltonikaConnectedDevicesReportComponent } from './teltonika-reporting/teltonika-connected-devices-report/teltonika-connected-devices-report.component';
import { TeltonikaUpdateDeviceByVersionComponent } from './modals/teltonika-update-device-by-version/teltonika-update-device-by-version.component';
import { TeltonikaUploadFirmwareComponent } from './modals/teltonika-upload-firmware/teltonika-upload-firmware.component';
import { TeltonikaUpdateDevicesLogComponent } from './teltonika-update-devices-log/teltonika-update-devices-log.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'Dashboard',
    pathMatch: 'full',
  },
  {
    path: 'Dashboard',
    data: {
      breadcrumb: 'Dashboard',
    },
    children: [
      {
        path: '',
        component: TeltonikaHomeComponent,
      },
      {
        path: 'device/:id/:tab',
        pathMatch: 'full',
        component: TeltonikaDeviceComponent,
        data: {
          breadcrumb: 'Device Details',
        },
      },
      {
        path: 'device/:id',
        component: TeltonikaDeviceComponent,
        data: {
          breadcrumb: 'Device Details',
        },
      },
    ]
  },
  {
    path: 'Reporting',
    data: {
      breadcrumb: 'Reporting',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',

        component: TeltonikaReportingComponent,
      },
      {
        path: 'devices',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Devices Reporting',
        },
        component: TeltonikaDeviceReportComponent,
      },
      {
        path: 'connected-devices',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Connected Devices Reporting',
        },
        component: TeltonikaConnectedDevicesReportComponent,
      },
    ]
  },
  {
    path: 'Tags',
    data: {
      breadcrumb: 'Tags',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Tags'
        },
        component: TeltonikaTagsComponent
      },
      {
        path: ':id',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Manage Tag Devices'
        },
        component: TeltonikaManageTagDevicesComponent
      }
    ]
  },
  {
    path: 'Tasks',
    data: {
      breadcrumb: 'Tasks',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Tasks',
        },
        component: TeltonikaTasksComponent,
      },
      {
        path: ':id',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Create/Update Task',
        },
        component: CreateUpdateTeltonikaTaskComponent,
      },
    ],
  },
  {
    path: 'Admin',
    data: {
      breadcrumb: 'Admin',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Tasks',
        },
        component: TeltonikaAdminComponent,
      },
      {
        path: 'UpdateDefaultConnectionCredentials',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Update Default Connection Credentials',
        },
        component: TeltonikaUpdateDefaultCredentialsModalComponent,
      },
      {
        path: 'UpdateEmailActionRequiredNotifications',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Update Email Action Required Notifications',
        },
        component: TeltonikaSelectEmailsModalComponent,
      },
      {
        path: 'UpdateTeltonikaDevice',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Update Teltonika Device',
        },
        component: TeltonikaUpdateDeviceModalComponent,
      },
      {
        path: 'CreateCustomTeltonikaDevice',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Create Custom Teltonika Device',
        },
        component: CreateCustomDeviceComponent,
      },
      {
        path: 'UpdateDeviceByVersion',
        pathMatch: 'full',
        data: {
          breadcrumb: 'Update Device by Version',
        },
        component: TeltonikaUpdateDeviceByVersionComponent,
      },
      {
        path: "UploadFirmware",
        pathMatch: 'full',
        data: {
          breadcrumb: 'Upload Firmware'
        },
        component: TeltonikaUploadFirmwareComponent,
      }
    ],
  },
  {
    path: 'UpdateDevicesLog',
    data: {
      breadcrumb: 'Update Devices Log',
    },
    component: TeltonikaUpdateDevicesLogComponent,
  },
  {
    path: 'AuditLog',
    data: {
      breadcrumb: 'Audit Log',
    },
    component: TeltonikaAuditLogComponent,
  },
  {
    path: 'terminal/:id/:ip',
    component: TeltonikaDeviceTerminalComponent,
    data: {
      breadcrumb: 'SSH Terminal',
    },
  },
  {
    path: 'recovery/:id',
    pathMatch: 'full',
    data: {
      breadcrumb: 'Recovery SSH',
    },
    component: TeltonikaDeviceReverseSshComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TeltonikaRoutingModule { }
